import React from 'react';
import PropTypes from 'prop-types';
import { Button } from "react-bootstrap";

import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';

import AuthImage from "../common/AuthImage";

const DesignsList = ({ data, loading }) => {
    const { SearchBar } = Search;
    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            Showing { from} to { to} of { size} Results
        </span>
    );

    const options = {
        paginationTotalRenderer: customTotal,
        showTotal: true,
    };


    const columns = [
        {
            text: '#',
            dataField: '_index',
            isDummyField: true,
            formatter: indexFormatter,
        },
        {
            text: 'Preview',
            dataField: '_preview',
            isDummyField: true,
            formatter: previewFormatter,
        },
        {
            text: 'Name',
            dataField: 'name',
            formatter: nameFormatter,
        },
        {
            text: 'Size',
            dataField: 'size',
            formatter: sizeFormatter,
        },
        {
            text: 'Action',
            dataField: '_action',
            isDummyField: true,
            formatter: actionFormatter,
        }
    ]

    function indexFormatter(cell, row, index) {
        return (
            index + 1
        )
    }
    function previewFormatter(cell, row) {
        return (
            <AuthImage 
                src={`${process.env.REACT_APP_FILE_SERVER}/resources/designs/${row._id}/thumbnail.png`} 
                className="tableTempPreview" 
                alt={row.name || 'Design preview'}
            />
        )
    }
    function nameFormatter(cell) {
        return (
            cell ? cell : 'Untitled'
        )
    }
    function sizeFormatter(cell) {
        return (
            cell ? `${cell.width} x ${cell.height}` : '-'
        )
    }
    function actionFormatter(cell, row) {
        return (
            <div className="tableTempActionBox">
                <Button className="tableTempAction" onClick={() => designHandler(row._id)}><i className="material-icons">design_services</i> Design</Button>
                {/* <Button className="tableTempAction" onClick={() => editHandler(cell)}><i className="material-icons">edit</i> Edit</Button> */}
                {/* <Button disabled className="tableTempAction" theme="danger"><i className="material-icons">delete</i> Delete</Button> */}
            </div>
        )
    }
    const designHandler = designId => {
        window.open(
            `${process.env.REACT_APP_DESIGN_EDITOR}/edit/design/${designId}`,
            '_blank',
            'noopener,noreferrer',
        );
    }

    return (
        <ToolkitProvider
            keyField="_id"
            data={data}
            columns={columns}
            search
        >
            {
                props => (
                    <div>
                        <SearchBar {...props.searchProps} />
                        <hr />
                        <BootstrapTable
                            {...props.baseProps}
                            pagination={paginationFactory(options)}
                            noDataIndication={() => loading
                                ? 'Loading designs...'
                                : 'This user has not created any designs yet.'}
                        />
                    </div>
                )
            }
        </ToolkitProvider>

    )
}

DesignsList.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    loading: PropTypes.bool,
};

DesignsList.defaultProps = {
    data: [],
    loading: false,
};

export default DesignsList;
